import React, {useState, useEffect} from 'react'
import { request_delete_product_segment } from '../requests'
import WarningModal from '../../../../../../modals/WarningModal'
import { onGetErrorMessage } from '../../../../../../shared/utility'


const DeleteProductSegmentModal = props => {
 
    const { id, open, onClose, onUpdateCompleted } = props

    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)

    useEffect(() => {
        setError('')
        setLoading(false)
    }, [open])

    const onSubmit = async() => {
        setLoading(true)
        setDisabled(true)
        try {
            await request_delete_product_segment(id)          
            onUpdateCompleted()
        } catch (error) {
            console.log(error)
            setError(onGetErrorMessage(error))
            setLoading(false)
        }
        setDisabled(false)
    }

    return(
        <WarningModal open={open} onClose={onClose} error={error} loading={loading} onSubmit={onSubmit} disabled={disabled}/>
    )
}

export default DeleteProductSegmentModal